export default "__VITE_ASSET__5b777fe2__"